import { Box, Drawer as MuiDrawer, SxProps, useTheme } from '@mui/material';
import {
  BottomDrawerComponentType,
  useBottomDrawer
} from 'core/stores/bottomDrawer';
import { UpdateConversationsBottomDrawer } from 'modules/conversations/components/UpdateConversationsBottomDrawer';
import { AnalyseActionsBottomDrawer } from 'modules/analyse/components/AnalyseActionsBottomDrawer';
import { AnalysesListActionsBottomDrawer } from 'modules/analyse/components/AnalysesListActionsBottomDrawer';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const container: SxProps = {
  width: '100%',
  padding: '20px 48px',
  gap: '32px',
  maxHeight: '40vm'
};

const CONTENT_COMPONENTS = {
  [BottomDrawerComponentType.UpdateConversations]:
    UpdateConversationsBottomDrawer,
  [BottomDrawerComponentType.AnalyseActions]: AnalyseActionsBottomDrawer,
  [BottomDrawerComponentType.AnalysesListActions]:
    AnalysesListActionsBottomDrawer
};

export const BottomDrawer = () => {
  const { palette } = useTheme();
  const { isOpen, closeBottomDrawer, drawerContentType, drawerComponentProps } =
    useBottomDrawer();
  const location = useLocation();

  const ContentComponent =
    drawerContentType && CONTENT_COMPONENTS[drawerContentType]
      ? CONTENT_COMPONENTS[drawerContentType]
      : null;

  useEffect(() => {
    closeBottomDrawer();
  }, [location.pathname]);

  return (
    <MuiDrawer
      anchor="bottom"
      open={isOpen}
      variant="persistent"
      onClose={closeBottomDrawer}
      ModalProps={{
        keepMounted: false
      }}
    >
      <Box
        sx={{ ...container, borderTop: `1px solid ${palette.customGrey.dark}` }}
      >
        {ContentComponent && <ContentComponent {...drawerComponentProps} />}
      </Box>
    </MuiDrawer>
  );
};
